__turbopack_context__.v({
  "data": "AMmY7G_data",
  "delimiter": "AMmY7G_delimiter",
});
